// src/state/middleware/updateInventoryMiddleware.ts
var getStockZeroAction = (menuTypeVersion) => (menuTypeVersion == null ? void 0 : menuTypeVersion.actionWhenCurrentStockZero) || "" /* NONE */;

export { getStockZeroAction };
